import { DEFAULT_LOCALE, getMessages } from "@/i18n";

/** Suppresses inline field error; checklist handles policy feedback. */
export const PASSWORD_POLICY_ERROR = "password-policy";

/** Default (de-DE) validation copy for unit tests and non-React callers. */
export const {
  passwordRequired: PASSWORD_REQUIRED_ERROR,
  passwordRepeatRequired: PASSWORD_REPEAT_REQUIRED_ERROR,
  firstNameTooLong: FIRST_NAME_TOO_LONG_ERROR,
  firstNameRequired: FIRST_NAME_REQUIRED_ERROR,
  firstNameInvalidFormat: FIRST_NAME_INVALID_FORMAT_ERROR,
  lastNameTooLong: LAST_NAME_TOO_LONG_ERROR,
  lastNameRequired: LAST_NAME_REQUIRED_ERROR,
  lastNameInvalidFormat: LAST_NAME_INVALID_FORMAT_ERROR,
  emailTooLong: EMAIL_TOO_LONG_ERROR,
  emailRequired: EMAIL_REQUIRED_ERROR,
  emailInvalidFormat: EMAIL_INVALID_FORMAT_ERROR,
  passwordMatchesEmail: PASSWORD_MATCHES_EMAIL_ERROR,
  passwordMismatch: PASSWORD_MISMATCH_ERROR,
} = getMessages(DEFAULT_LOCALE).validation;
